import { Controller } from "stimulus"

export default class extends Controller {

  click(event) {
    if(this.data.has('target')) {
      document.querySelector(`ul.nav-tabs>li>a[href='#${this.data.get('target')}']`).click()
    }
  }
}